import { render, staticRenderFns } from "./vSingleNutrientReportModal.vue?vue&type=template&id=71733ae7&scoped=true"
import script from "./vSingleNutrientReportModal.vue?vue&type=script&lang=ts"
export * from "./vSingleNutrientReportModal.vue?vue&type=script&lang=ts"
import style0 from "./vSingleNutrientReportModal.vue?vue&type=style&index=0&id=71733ae7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71733ae7",
  null
  
)

export default component.exports